import React from 'react'
import PropTypes from 'prop-types'

import FormFooterGeneral from './FormFooterGeneral'
import FormFooterBonial from 'themes/bonial/components/FormFooter'


const FormFooter = (params) => {
    const {
        theme,
        ...props
    } = params

    if (theme === 'bonial') {
        return <FormFooterBonial {...props} />
    }

    return <FormFooterGeneral {...props} />
}

FormFooter.propTypes = {
    theme: PropTypes.string.isRequired
}

export default FormFooter
